var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cell-body" },
    [
      _vm.isEmpty
        ? [_c("span", { staticClass: "padding" })]
        : _vm.isOne
        ? [
            _vm.hasApproved
              ? _c("vacations-approved-day-legend", {
                  staticClass: "padding",
                  attrs: { withTitle: false },
                  on: {
                    click: function ($event) {
                      return _vm.appointmentClicked(_vm.cell.data[0])
                    },
                  },
                })
              : _vm.hasWaitingConfirmation
              ? _c("vacation-confirm-waiting-day-legend", {
                  staticClass: "padding",
                  attrs: { withTitle: false },
                  on: {
                    click: function ($event) {
                      return _vm.appointmentClicked(_vm.cell.data[0])
                    },
                  },
                })
              : _vm.hasMeeting
              ? _c("vacations-need-meeting-day-legend", {
                  staticClass: "padding",
                  attrs: { withTitle: false },
                  on: {
                    click: function ($event) {
                      return _vm.appointmentClicked(_vm.cell.data[0])
                    },
                  },
                })
              : _vm.hasRejected
              ? _c("vacations-rejected-day-legend", {
                  staticClass: "padding",
                  attrs: { withTitle: false },
                  on: {
                    click: function ($event) {
                      return _vm.appointmentClicked(_vm.cell.data[0])
                    },
                  },
                })
              : _vm._e(),
          ]
        : [
            _c("div", { staticClass: "dropdown" }, [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  attrs: { "aria-labelledby": "dropdownMenuButton" },
                },
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "a",
                    {
                      key: item.key,
                      staticClass: "dropdown-item",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.appointmentClicked(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.permissionId(item)) +
                          " " +
                          _vm._s(_vm.pemissionStatus(item)) +
                          " ( "
                      ),
                      _c("formatted-date-component", {
                        attrs: { val: item.dateStart },
                      }),
                      _vm._v(" - "),
                      _c("formatted-date-component", {
                        attrs: { val: item.dateEnd },
                      }),
                      _vm._v(" ) "),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn dropdown-toggle",
        attrs: {
          type: "button",
          id: "dropdownMenuButton",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/IC_Vacaciones_Pendiente.png"),
            alt: "type",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }